const DEVICE_TYPE = {
  DISTANCE: 'NDDS75_DISTANCE',
}

export {
  DEVICE_TYPE,
};
